import React from 'react';
import PropTypes from 'prop-types';

import Activity from './activity';

const ActivityList = ({ activities }) => {
  const renderActivity = activity => (
    <Activity key={activity.activity_id + activity.time} {...activity} />
  );

  if (activities.length === 0) {
    return (
      <p className="fs-activity-calendar-list-no-items">
        There are currently no activities planned on this date.
      </p>
    );
  }

  return (
    <ul className="fs-activity-calendar-list">
      {activities.map(renderActivity)}
    </ul>
  );
};

ActivityList.propTypes = {
  activities: PropTypes.array.isRequired,
};

export default ActivityList;



// WEBPACK FOOTER //
// ./components/activity-list/index.js